<template>
  <div class="other-swiper-view swiper-view">
    <div class="view-list-wrap">
      <div class="course-list">
        <CourseItem
          v-for="item in courseList"
          :key="item.id"
          v-bind="item"
        />
        <div class="no-content"
					 v-show="courseList.length === 0">———— 暂无内容 ————</div>
      </div>
    </div>
  </div>
</template>
<script>
import CourseItem from '../../components/CourseItem'
export default {
  name: 'other',
  components: {
    CourseItem
  },
  props: ['courseList']
}
</script>
<style lang="stylus" scoped>
.other-swiper-view {
  min-height: 890px;
  .course-list {
		padding: 20px 0 100px 0;

		.course-item-comp {
			margin-left: 30px;
      margin-bottom: 30px;
		}
    .no-content {
			height: 90px;
			line-height: 90px;
			color: #999;
			text-align: center;
		}
	}
}
</style>


